import styled from 'styled-components'

export const MedicineContainer = styled.div`
     color: white;
     text-align: center;
     padding: 50px 100px;
     display: flex;
     flex-direction: column;
     align-items: center;
     max-width: 1500px;
     margin: 0 auto;

     h1{
        text-transform: uppercase;
     }

     p{
        width: 80%;
        margin-top: 24px;

    @media (max-width: 550px) {
      /* Phones */
       width: 90%;
    }

    @media (max-width: 1100px) {
        /* Tablets */
        width: 90%;
    }
    }

     @media (max-width: 550px) {
      /* Phones */
       grid-template-columns: 1fr;
       padding: 0 30px;
    }

    @media (max-width: 1100px) {
        /* Tablets */
        grid-template-columns: 1fr;
        padding: 0x 30px;
    }
`

export const PlacesContainer = styled.div`
    margin-top: 100px;
    display: flex;

    @media (max-width: 550px) {
      /* Phones */
       flex-direction: column;
    }

    @media (max-width: 1100px) {
        /* Tablets */
        flex-direction: column;
    }
`

export const PlaceItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    color: white;
    background-image: linear-gradient(rgba(40, 44, 52, 1), rgba(118, 130, 154, 0.05));
    width: 260px;
    height: 260px;
    border-radius: 12px;
    margin-right: 20px;

    p{
      margin: 0;
    }

    p:nth-child(3){
      margin-top: -10px;
      margin-bottom: 20px;
    }

    h3{
      font-size: 3em;
      margin-top: 12px;
    }

    img{
      margin-top: 24px;
    }

    @media (max-width: 550px) {
      /* Phones */
       margin-bottom: 20px;
    }

    @media (max-width: 1100px) {
        /* Tablets */
        margin-bottom: 20px;
    }
`

export const CheckItem = styled.div`
    width: 80px;
    height: 80px;
    background-image: linear-gradient(rgba(124, 1, 0, 1), rgba(226, 2, 0, 1));
    border-radius: 50%;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    margin-top: -30px;
`

export const ImageSection = styled.div`
  position: absolute;
  opacity: 0.9;
  right: 0;
  margin-top: 120px;

  @media (max-width: 550px) {
    /* Phones */
    opacity: 0.4;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    opacity: 0.4;
  }
`

export const ImageText = styled.p`
  margin-top: 20px !important;
`
